import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchCompanyDetailsQueryVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type FetchCompanyDetailsQuery = (
  { __typename: 'Query' }
  & { company?: SchemaTypes.Maybe<(
    { __typename: 'Company' }
    & CompanyItemDataFragment
  )> }
);

export type CompanyItemDataFragment = (
  { __typename: 'Company' }
  & Pick<SchemaTypes.Company, 'id' | 'name' | 'shortName' | 'isActive' | 'createdAt' | 'enabledModules'>
  & { contactInfo: (
    { __typename: 'CompanyContactInfo' }
    & Pick<SchemaTypes.CompanyContactInfo, 'name' | 'email' | 'phone' | 'address'>
  ), subscriptions: Array<(
    { __typename: 'CompanySubscription' }
    & Pick<SchemaTypes.CompanySubscription, 'durationMonths' | 'freeTrialDays' | 'extensionDays' | 'effectiveStartDate' | 'effectiveEndDate' | 'startDate' | 'endDate' | 'maxUserLicenses' | 'usedLicenses' | 'renewalReminderDays'>
  )>, settings: (
    { __typename: 'CompanyGeneralSettings' }
    & Pick<SchemaTypes.CompanyGeneralSettings, 'dataRetentionPeriod' | 'enforceOtp2FA'>
    & { notifications?: SchemaTypes.Maybe<(
      { __typename: 'CompanyNotificationSettings' }
      & Pick<SchemaTypes.CompanyNotificationSettings, 'userRegistrationMode' | 'reportAvailabilityNotification' | 'emailSenderName' | 'welcomeEmailText' | 'reportAvailabilityEmailText'>
    )> }
  ), roleSettings: Array<(
    { __typename: 'CompanyRoleSetting' }
    & Pick<SchemaTypes.CompanyRoleSetting, 'role' | 'customName' | 'isEnabled'>
  )> }
);

export type FetchAvailableModulesQueryVariables = SchemaTypes.Exact<{
  filter?: SchemaTypes.InputMaybe<SchemaTypes.ModuleDefinitionFilteringRule>;
  pagination?: SchemaTypes.InputMaybe<SchemaTypes.Pagination>;
  sort?: SchemaTypes.InputMaybe<SchemaTypes.ModuleDefinitionSortingRule>;
}>;


export type FetchAvailableModulesQuery = (
  { __typename: 'Query' }
  & { availableModules: (
    { __typename: 'PaginatedModuleDefinition' }
    & Pick<SchemaTypes.PaginatedModuleDefinition, 'count'>
    & { items: Array<(
      { __typename: 'AssessmentModuleDefinition' }
      & AssessmentModuleFieldsFragment
    ) | (
      { __typename: 'ExternalIntegrationModuleDefinition' }
      & ExternalIntegrationModuleFieldsFragment
    ) | (
      { __typename: 'ReportingModuleDefinition' }
      & ReportingModuleFieldsFragment
    ) | (
      { __typename: 'TrainingModuleDefinition' }
      & TrainingModuleFieldsFragment
    )> }
  ) }
);

export type AssessmentModuleFieldsFragment = (
  { __typename: 'AssessmentModuleDefinition' }
  & Pick<SchemaTypes.AssessmentModuleDefinition, 'id' | 'identifier' | 'name' | 'category' | 'subCategory' | 'levelOrVariant' | 'tags' | 'isActive'>
);

export type TrainingModuleFieldsFragment = (
  { __typename: 'TrainingModuleDefinition' }
  & Pick<SchemaTypes.TrainingModuleDefinition, 'id' | 'identifier' | 'name' | 'category' | 'subCategory' | 'levelOrVariant' | 'tags' | 'isActive'>
);

export type ExternalIntegrationModuleFieldsFragment = (
  { __typename: 'ExternalIntegrationModuleDefinition' }
  & Pick<SchemaTypes.ExternalIntegrationModuleDefinition, 'id' | 'identifier' | 'name' | 'category' | 'isActive'>
);

export type ReportingModuleFieldsFragment = (
  { __typename: 'ReportingModuleDefinition' }
  & Pick<SchemaTypes.ReportingModuleDefinition, 'id' | 'identifier' | 'name' | 'category' | 'isActive'>
);

export const CompanyItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyItemData on Company {
  id
  name
  shortName
  isActive
  createdAt
  contactInfo {
    name
    email
    phone
    address
  }
  subscriptions {
    durationMonths
    freeTrialDays
    extensionDays
    effectiveStartDate
    effectiveEndDate
    startDate
    endDate
    maxUserLicenses
    usedLicenses
    renewalReminderDays
  }
  settings {
    dataRetentionPeriod
    notifications {
      userRegistrationMode
      reportAvailabilityNotification
      emailSenderName
      welcomeEmailText
      reportAvailabilityEmailText
    }
    enforceOtp2FA
  }
  roleSettings {
    role
    customName
    isEnabled
  }
  enabledModules
}
    `;
export const AssessmentModuleFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment AssessmentModuleFields on AssessmentModuleDefinition {
  id
  identifier
  name
  category
  subCategory
  levelOrVariant
  tags
  isActive
}
    `;
export const TrainingModuleFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainingModuleFields on TrainingModuleDefinition {
  id
  identifier
  name
  category
  subCategory
  levelOrVariant
  tags
  isActive
}
    `;
export const ExternalIntegrationModuleFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment ExternalIntegrationModuleFields on ExternalIntegrationModuleDefinition {
  id
  identifier
  name
  category
  isActive
}
    `;
export const ReportingModuleFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment ReportingModuleFields on ReportingModuleDefinition {
  id
  identifier
  name
  category
  isActive
}
    `;
export const FetchCompanyDetailsDocument = /*#__PURE__*/ gql`
    query FetchCompanyDetails($id: ObjectID!) {
  company(id: $id) {
    ...CompanyItemData
  }
}
    ${CompanyItemDataFragmentDoc}`;

/**
 * __useFetchCompanyDetailsQuery__
 *
 * To run a query within a React component, call `useFetchCompanyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCompanyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCompanyDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCompanyDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchCompanyDetailsQuery, FetchCompanyDetailsQueryVariables> & ({ variables: FetchCompanyDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCompanyDetailsQuery, FetchCompanyDetailsQueryVariables>(FetchCompanyDetailsDocument, options);
      }
export function useFetchCompanyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCompanyDetailsQuery, FetchCompanyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCompanyDetailsQuery, FetchCompanyDetailsQueryVariables>(FetchCompanyDetailsDocument, options);
        }
export function useFetchCompanyDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCompanyDetailsQuery, FetchCompanyDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCompanyDetailsQuery, FetchCompanyDetailsQueryVariables>(FetchCompanyDetailsDocument, options);
        }
export type FetchCompanyDetailsQueryHookResult = ReturnType<typeof useFetchCompanyDetailsQuery>;
export type FetchCompanyDetailsLazyQueryHookResult = ReturnType<typeof useFetchCompanyDetailsLazyQuery>;
export type FetchCompanyDetailsSuspenseQueryHookResult = ReturnType<typeof useFetchCompanyDetailsSuspenseQuery>;
export type FetchCompanyDetailsQueryResult = Apollo.QueryResult<FetchCompanyDetailsQuery, FetchCompanyDetailsQueryVariables>;
export const FetchAvailableModulesDocument = /*#__PURE__*/ gql`
    query FetchAvailableModules($filter: ModuleDefinitionFilteringRule, $pagination: Pagination, $sort: ModuleDefinitionSortingRule) {
  availableModules(filter: $filter, pagination: $pagination, sort: $sort) {
    count
    items {
      ... on AssessmentModuleDefinition {
        __typename
        ...AssessmentModuleFields
      }
      ... on TrainingModuleDefinition {
        __typename
        ...TrainingModuleFields
      }
      ... on ExternalIntegrationModuleDefinition {
        __typename
        ...ExternalIntegrationModuleFields
      }
      ... on ReportingModuleDefinition {
        __typename
        ...ReportingModuleFields
      }
    }
  }
}
    ${AssessmentModuleFieldsFragmentDoc}
${TrainingModuleFieldsFragmentDoc}
${ExternalIntegrationModuleFieldsFragmentDoc}
${ReportingModuleFieldsFragmentDoc}`;

/**
 * __useFetchAvailableModulesQuery__
 *
 * To run a query within a React component, call `useFetchAvailableModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAvailableModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAvailableModulesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFetchAvailableModulesQuery(baseOptions?: Apollo.QueryHookOptions<FetchAvailableModulesQuery, FetchAvailableModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAvailableModulesQuery, FetchAvailableModulesQueryVariables>(FetchAvailableModulesDocument, options);
      }
export function useFetchAvailableModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAvailableModulesQuery, FetchAvailableModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAvailableModulesQuery, FetchAvailableModulesQueryVariables>(FetchAvailableModulesDocument, options);
        }
export function useFetchAvailableModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAvailableModulesQuery, FetchAvailableModulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAvailableModulesQuery, FetchAvailableModulesQueryVariables>(FetchAvailableModulesDocument, options);
        }
export type FetchAvailableModulesQueryHookResult = ReturnType<typeof useFetchAvailableModulesQuery>;
export type FetchAvailableModulesLazyQueryHookResult = ReturnType<typeof useFetchAvailableModulesLazyQuery>;
export type FetchAvailableModulesSuspenseQueryHookResult = ReturnType<typeof useFetchAvailableModulesSuspenseQuery>;
export type FetchAvailableModulesQueryResult = Apollo.QueryResult<FetchAvailableModulesQuery, FetchAvailableModulesQueryVariables>;